export default {"src":"https://images-cdn.curipod.com/d-f768e792/_next/static/media/rocket.9360f2a3.svg","height":199,"width":200};